import { render, staticRenderFns } from "./RadioConfig.vue?vue&type=template&id=d68b085a&scoped=true"
import script from "./RadioConfig.vue?vue&type=script&lang=js"
export * from "./RadioConfig.vue?vue&type=script&lang=js"
import style0 from "./RadioConfig.vue?vue&type=style&index=0&id=d68b085a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68b085a",
  null
  
)

export default component.exports